module.exports = __webpack_public_path__ + "78f9867e8d54062564653c19eade2716.png";